import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
// import { Provider } from "react-redux";
// import Redux from "./redux/store";

// import { PersistGate } from "redux-persist/integration/react";

import { Provider } from "react-redux";
import Store from "./redux/store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

const store = Store();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistStore(store)} loading={null}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js